export const GET_FUND = "/fund/fetch_fund/";
export const CREATE_FUND = "/fund/submit_fund/";
